import type { FileRecord, FileRecordVersion } from "@cohesive/api-client";
import {
  AudioContent,
  FallbackContent,
  HtmlContent,
  ImageContent,
  MarkdownContent,
  OfficeContent,
  PdfContent,
  SpreadsheetContent,
  TextContent,
  VideoContent,
} from "../content";
import { classifyFileRecord } from "../contentType";
import { FileRecordVersionPreviewPaneContext } from "./FileRecordVersionPreviewPaneContext";

function renderPreviewContent(record: FileRecord) {
  const kind = classifyFileRecord(record);
  switch (kind) {
    case "image":
      return <ImageContent record={record} />;
    case "pdf":
      return <PdfContent record={record} />;
    case "video":
      return <VideoContent record={record} />;
    case "audio":
      return <AudioContent record={record} />;
    case "markdown":
      return <MarkdownContent record={record} />;
    case "html":
      return <HtmlContent record={record} />;
    case "text":
      return <TextContent record={record} />;
    case "office":
      return <OfficeContent record={record} />;
    case "spreadsheet":
      return <SpreadsheetContent record={record} />;
    case "fallback":
    default:
      return (
        <FallbackContent
          record={record}
          onOpenExternal={
            record.url
              ? () => window.open(record.url!, "_blank", "noopener,noreferrer")
              : undefined
          }
        />
      );
  }
}

/** Left-hand preview pane inside the version history dialog (API-backed files). */
export function FileRecordVersionPreviewPane({
  record,
  selectedVersion,
}: {
  record: FileRecord;
  selectedVersion: FileRecordVersion | null;
}) {
  return (
    <FileRecordVersionPreviewPaneContext.Provider value={selectedVersion}>
      <div className="h-full min-h-0 w-full overflow-hidden bg-muted/15">
        {selectedVersion ? (
          renderPreviewContent(record)
        ) : (
          <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
            Select a version to preview.
          </div>
        )}
      </div>
    </FileRecordVersionPreviewPaneContext.Provider>
  );
}
